<template>
  <div id="data-list-list-view" class="data-list-container">
    <employee-side-view
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
      :projectId="selectedProjectId"
      @onEmployeeUpdated="employeeUpdated"
      @onEmployeeInserted="employeeInserted"
    />
    <vx-card ref="listCard" :title="$t('GradeControl.Employee.Title')" title-color="black" refresh-content-action @refresh="refreshEmployeeList"> 
      <vs-table
            ref="table"
            v-model="selected"
            pagination
            :max-items="itemsPerPage"
            search
            :data="employees"
          >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-add"
                @click="addNewData"
              >{{$t('AddNew')}}</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <Pager
                :currentPage="currentPage"
                :itemsPerPage="itemsPerPage"
                :totalCount="employees.length"
                :queriedItems="queriedItems"
                :pageSizes="[10,20,50]"
                @pageChanged="onPageChanged"
              ></Pager>
            </vs-col>
          </vs-row>
        </div>
        <template slot="thead">
          <vs-th sort-key="code">{{$t('GradeControl.Employee.Code')}}</vs-th>
          <vs-th sort-key="firstName">{{$t('GradeControl.Employee.FirstName')}}</vs-th>
          <vs-th sort-key="lastName">{{$t('GradeControl.Employee.LastName')}}</vs-th>
          <vs-th sort-key="isActive">{{$t('GradeControl.Employee.IsActive')}}</vs-th>
          <vs-th>{{$t('Action')}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td width="250px;">
                <p class="font-medium truncate">{{ tr.code }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ tr.firstName }}</p>
              </vs-td>
               <vs-td>
                <p class="font-medium truncate">{{ tr.lastName }}</p>
              </vs-td>
              <vs-td width="75px;">
                <vs-checkbox v-model="tr.isActive" class="mb-2" :disabled="true" ></vs-checkbox>
              </vs-td>
              <vs-td width="100px" class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="openDeleteConfirm(tr.employeeId, tr.code)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>

import employeeSideView from "./components/employeeSideView.vue";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import { Pager } from "../../../../shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    Pager,
    employeeSideView
  },
  data() {
    return {
      selected: [],    
      selectedProjectId: null,
      itemsPerPage: 20,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    employees() {
      return this.$store.state.gradeControl.employees;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.employees.length;
    }
  },
  methods: {
    refreshEmployeeList() {
      this.$store.dispatch("gradeControl/fetchEmployeeListItems", this.selectedProjectId).then(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id, code) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: code,
        text: this.$t('GradeControl.Employee.ConfirmDelete', { code }),
        accept: this.deleteData,
        parameters: id
      });
    },
    deleteData(id) {
      this.$store.dispatch("gradeControl/removeEmployee", id)
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: this.$t("Success"),
            text: this.$t("GradeControl.Employee.EmployeeDeleted")
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    employeeUpdated() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });

      this.toggleDataSidebar(false);

    },

    employeeInserted() {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("InsertSuccess"),
        color: "success",
        iconPack: 'feather',
        icon:'icon-check'
      });
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
   
  },
  mounted() {

    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }

    this.isMounted = true;

  }
};
</script>

<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>